export default __webpack_public_path__ + "static/media/partner-admin.84540b4e.svg";